import React from 'react';

// PROTOTYPE
import Alert from '../prototype/Alert';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';
import Button from 'core/tools/Button';

// STYLES
import styles from './loading.module.scss';

// MAIN COMPONENT
const Loading = ({
  message,
  controller,
  ...props
}) => (
  <Alert
    {...props}
    message={(<>
      <Sprite.Loader />
      <span className="loading">{message}</span>
      {!!controller &&
        <Button.Link
          className={styles.button}
          variant="custom"
          label="Cancel"
          onClick={() => controller.abort()}
        />
      }
    </>)}
  />
)

// EXPORT
export default Loading;
